import { Industry } from '__generated__/Industry';

export class Industries {
    industries: Industry[];

    constructor(industries: Industry[]) {
        this.industries = industries;
    }

    find(key: string) {
        const industry = this.industries.find(industry => industry.key == key);

        return industry ? industry.title : null;
    }
}
